import React, { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import CommonAddErpModal from './components/CommonAddErpModal';
import ListAddErpModal from './components/ListAddErpModal';

function AddErpUser(props, ref) {
  const [openParams, setOpenParams] = useState(null);
  const [visible, setVisible] = useState(false);
  const midwareRef = useRef();

  /******* 向外暴露的三个实例方法---start *******/
  useImperativeHandle(ref, () => ({
    open: (params) => {
      //向外暴露主动打开弹窗
      handleOpen(params);
    },
    close: (params) => {
      //向外暴露主动关闭弹窗
      handleClose(params);
    },
    refreshList: () => {
      //向外暴露主动刷新erpList,仅当list类型时有效
      handleRefreshList();
    },
  }));

  function handleOpen(params) {
    setOpenParams(params);
    setVisible(true);
  }

  function handleClose(params) {
    setVisible(false);
  }

  function handleRefreshList() {
    midwareRef?.current?.handleInlineRefreshList();
  }
  /******* 向外暴露的三个实例方法---end *******/

  /* *********************************************************
   *            【【 四个比较明显的事件，中间层过滤下 】】           *
   ************************************************************ */
  /************** 取消回调 **************/
  function handleMidwareOnCancel(e) {
    openParams && openParams?.onCancel && typeof openParams.onCancel === 'function' && openParams.onCancel(e);
    setVisible(false);
  }

  /************** 成功回调 **************/
  function handleMidwareOnOk(e, successCallBack) {
    openParams && openParams?.onOk && typeof openParams.onOk === 'function' && openParams.onOk(e, successCallBack);
  }

  /************** 删除事件回调 **************/
  function handleMidwareOnDeleteItem(ditem, delCallBack) {
    openParams &&
      openParams?.onDeleteItem &&
      typeof openParams.onDeleteItem === 'function' &&
      openParams.onDeleteItem(ditem, delCallBack);
  }

  /************** 转移组长权限事件回调 **************/
  function handleMidwareOnTranslateOwnerItem(titem, transCallBack) {
    openParams &&
      openParams?.onTranslateOwner &&
      typeof openParams.onTranslateOwner === 'function' &&
      openParams.onTranslateOwner(titem, transCallBack);
  }

  return (
    <>
      {openParams?.type === 'list' ? (
        <ListAddErpModal
          ref={midwareRef}
          visible={visible}
          onMidwareModalOk={handleMidwareOnOk}
          onMidwareModalCancel={handleMidwareOnCancel}
          onMidwareOperateDeleteItem={handleMidwareOnDeleteItem}
          onMidwareOperateTranslateOwnerItem={handleMidwareOnTranslateOwnerItem}
          {...openParams}
        />
      ) : (
        <CommonAddErpModal
          visible={visible}
          onMidwareModalOk={handleMidwareOnOk}
          onMidwareModalCancel={handleMidwareOnCancel}
          {...openParams}
        />
      )}
    </>
  );
}

export default forwardRef(AddErpUser);
